"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var parameters_1 = __importDefault(require("@/config/parameters"));
var vue2_leaflet_1 = require("vue2-leaflet");
var leaflet_1 = require("leaflet");
var vue2_leaflet_vectorgrid_1 = __importDefault(require("vue2-leaflet-vectorgrid"));
var filters_1 = require("@/filter/filters");
var PointOfInterestMapSide_vue_1 = __importDefault(require("@/components/point-of-interest/map-side/PointOfInterestMapSide.vue"));
var DateRangePicker_vue_1 = __importDefault(require("@/components/date-range/DateRangePicker.vue"));
var dayjs_1 = __importDefault(require("dayjs"));
var vue_typeahead_bootstrap_1 = __importDefault(require("vue-typeahead-bootstrap"));
var MapExplorer = /** @class */ (function (_super) {
    __extends(MapExplorer, _super);
    function MapExplorer() {
        var _this = _super.call(this) || this;
        _this.loader = true;
        _this.featureCollection = {
            features: [],
            type: 'FeatureCollection'
        };
        _this.tileServerUrl = parameters_1.default.mapConfiguration.tileServerUrl;
        _this.attribution = parameters_1.default.mapConfiguration.attribution;
        _this.partnershipRoutesTileServer = parameters_1.default.mapConfiguration.partnershipRoutesTileServerUrl + "/" + _this.$route.params.partnershipSlug + "/{z}/{x}/{y}.pbf";
        _this.partnershipRoutesOptions = {
            interactive: true,
            maxNativeZoom: 14,
            vectorTileLayerStyles: {
                "santiagodecompostela": parameters_1.default.mapConfiguration.pathStyles.partnershipRoutes,
                "rome": parameters_1.default.mapConfiguration.pathStyles.partnershipRoutes,
                "saintolav": parameters_1.default.mapConfiguration.pathStyles.partnershipRoutes,
                "csiksomlyo": parameters_1.default.mapConfiguration.pathStyles.partnershipRoutes,
            }
        };
        _this.icon = new leaflet_1.Icon({
            iconUrl: require('@/assets/images/Markers/red-marker.png'),
            iconSize: [60, 60],
            iconAnchor: [30, 59],
            className: 'marker-icon-selected'
        });
        _this.searchText = '';
        _this.pointOfInterestIdSelected = null;
        _this.dateRange = {
            start: null,
            end: null
        };
        _this.categories = [];
        _this.imagesCDNHost = parameters_1.default.cdn.host;
        return _this;
    }
    MapExplorer.prototype.mounted = function () {
        var _this = this;
        var _a, _b;
        this.$refs.MapViewer.setCenter(new leaflet_1.LatLng((_a = this.partnership.country) === null || _a === void 0 ? void 0 : _a.gps_latitude, (_b = this.partnership.country) === null || _b === void 0 ? void 0 : _b.gps_longitude));
        this.$getAllCategoriesService.request(this.partnership.id).then(function (categories) {
            _this.categories = categories;
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    MapExplorer.prototype.onKeyUp = function () {
        this.onUserInteraction();
    };
    MapExplorer.prototype.onZoom = function () {
        this.minLatitude = this.$refs.MapViewer.mapObject.getBounds()._northEast.lat;
        this.minLongitude = this.$refs.MapViewer.mapObject.getBounds()._northEast.lng;
        this.maxLatitude = this.$refs.MapViewer.mapObject.getBounds()._southWest.lat;
        this.maxLongitude = this.$refs.MapViewer.mapObject.getBounds()._southWest.lng;
        this.onUserInteraction();
    };
    MapExplorer.prototype.clearSearchText = function () {
        this.searchText = '';
        this.onUserInteraction();
    };
    MapExplorer.prototype.onRangeDateSelected = function () {
        this.onUserInteraction();
    };
    MapExplorer.prototype.onAutocompleteSelection = function () {
        this.onUserInteraction();
    };
    MapExplorer.prototype.onClearDateRange = function () {
        this.dateRange.start = null;
        this.dateRange.end = null;
        this.onUserInteraction();
    };
    MapExplorer.prototype.onUserInteraction = function () {
        var _this = this;
        clearTimeout(this.lastZoomChangedTimeout);
        this.lastZoomChangedTimeout = setTimeout(function () {
            _this.httpRequest();
        }, 1500);
    };
    MapExplorer.prototype.httpRequest = function () {
        var _this = this;
        var requestBody = {
            min_latitude: this.minLatitude,
            min_longitude: this.minLongitude,
            max_latitude: this.maxLatitude,
            max_longitude: this.maxLongitude,
            partnership_slug: this.partnership.slug,
            iso_code: this.$i18n.locale,
            search_text: this.searchText.length > 2 ? this.searchText : null,
            date_from: this.dateRange.start ? this.formatDate(this.dateRange.start) : null,
            date_to: this.dateRange.end ? this.formatDate(this.dateRange.end) : null
        };
        this.$searchBoundingBoxService.request(requestBody).then(function (response) {
            _this.featureCollection = response;
            _this.loader = false;
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    MapExplorer.prototype.viewPointOfInterest = function (pointOfInterestId) {
        this.pointOfInterestIdSelected = pointOfInterestId;
    };
    MapExplorer.prototype.closePreviewPointOfInterest = function () {
        this.pointOfInterestIdSelected = null;
    };
    MapExplorer.prototype.formatDate = function (date) {
        return dayjs_1.default(date).format('YYYY-MM-DD HH:mm:ss');
    };
    MapExplorer.prototype.serializer = function (category) {
        if (category.translations === undefined) {
            return '';
        }
        return filters_1.translation(category.translations, this.$i18n.locale, 'description');
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], MapExplorer.prototype, "partnership", void 0);
    MapExplorer = __decorate([
        vue_property_decorator_1.Component({
            name: 'MapExplorer',
            components: {
                LMap: vue2_leaflet_1.LMap,
                LTileLayer: vue2_leaflet_1.LTileLayer,
                LMarker: vue2_leaflet_1.LMarker,
                LTooltip: vue2_leaflet_1.LTooltip,
                LCircleMarker: vue2_leaflet_1.LCircleMarker,
                PointOfInterestMapSide: PointOfInterestMapSide_vue_1.default,
                DateRangePicker: DateRangePicker_vue_1.default,
                VueTypeaheadBootstrap: vue_typeahead_bootstrap_1.default,
                LProtobuf: vue2_leaflet_vectorgrid_1.default
            },
            filters: {
                translation: filters_1.translation,
                getFirstImageUrl: filters_1.getFirstImageUrl,
                dateFormat: filters_1.dateFormat
            }
        })
    ], MapExplorer);
    return MapExplorer;
}(vue_1.default));
exports.default = MapExplorer;
